import { createFileRoute } from '@tanstack/react-router'

import { SuitesPage } from '@/features/testing/testing-pages'

export const Route = createFileRoute('/suites')({ component: SuitesPage })
